var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('error-panel',{attrs:{"showInPopup":"false"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar navbar-dark bg-dark"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/logo-text-small.png","alt":"logo"}})])])
}]

export { render, staticRenderFns }